'use server'

import { createClient } from '@repo/db/server'
import { cookies } from 'next/headers'
import { redirect } from 'next/navigation'
import { getCurrentUserPermissions } from '@/lib/permissions'
import { recordSessionActivity } from '@/lib/operator-session'
import { createAuditLog } from '@/lib/audit-log'

export async function logout() {
  const supabase = await createClient()

  // Operatör oturumunu kapat (signOut'tan ÖNCE — sonrasında izin bağlamı gider).
  // Best-effort: hata çıkışı engellemez.
  try {
    const perms = await getCurrentUserPermissions()
    await recordSessionActivity({
      userId: perms.userId,
      tenantId: perms.tenantId,
      event: 'logout',
      logoutReason: 'manual',
    })
    // Çıkışı merkezi Loglar'a da yaz.
    await createAuditLog({
      perms,
      action: 'operator.logout',
      resource: { type: 'user', id: perms.userId, label: null },
    })
  } catch {
    // oturum/izin çözülemedi — yine de çıkışa devam
  }

  await supabase.auth.signOut()

  // Activity cookie'yi temizle — aksi halde eski timestamp kalır ve
  // yeniden giriş yapıldığında middleware idle timeout'u hemen tetikler.
  const cookieStore = await cookies()
  cookieStore.delete('opop-admin-last-activity')

  redirect('/login')
}
